import Categories from 'components/blog/categories'
import Image from 'next/legacy/image'
import Link from 'next/link'
import AuthorCardSection from '../../author'
import s from './styles.module.css'

export default function FeatureFlatCard({ categories, post }) {
  return (
    <article className={s.card}>
      <Link href={`/blog/${post.fields.slug}`} className={s.postLink}>
        <div className={s.imageWrapper}>
          {post.fields.featureImage && (
            <Image
              alt={post.fields.featureImage.fields.title}
              src={`https:${post.fields.featureImage.fields.file.url}`}
              layout="fill"
              objectFit="cover"
            />
          )}
        </div>
        <div>
          <Categories categories={categories} className={s.categories} />
          <h2 className={s.title}>{post.fields.title}</h2>
        </div>
        <AuthorCardSection post={post} />
      </Link>
    </article>
  )
}
